export default __webpack_public_path__ + "static/media/success.6fbe4303.svg";